import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wallet, Banknote } from 'lucide-react';
// import services
import { getWithdrawHistory } from '../services/admin.service';
// import lib
import { dateTimeFormat } from '../lib/dateHelper';
// import custom components
import DataTable from '../custom/DataTable';
import BankAccountView from '../components/BankAccountView';

const WithdrawHistory = () => {

    // hooks
    const navigate = useNavigate();
    const columns = [
        {
            key: "week",
            text: "Week",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "txid",
            text: "Txid",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "userCode",
            text: "User Id",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "userName",
            text: "Name",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ userId }) => userId?.userName || '-'
        },
        {
            key: "phone",
            text: "Phone",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ userId }) => userId?.phone || '-'
        },
        {
            key: "totalAmount",
            text: "Total Amount",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "fee",
            text: "Fee (5%)",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "gst",
            text: "GST (5%)",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "withdrawAmount",
            text: "Withdraw Amount",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "status",
            text: "Status",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ status }) => {
                return (
                    <span className={`px-3 py-1 bg-${status == 'Completed' ? 'green' : status == 'Pending' ? 'blue' : 'red'}-100 text-${status == 'Completed' ? 'green' : status == 'Pending' ? 'blue' : 'red'}-700 rounded-full text-sm font-medium`}>
                        {status}
                    </span>
                )
            }
        },
        {
            key: "createdAt",
            text: "Created At",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ createdAt }) => {
                return dateTimeFormat(createdAt);
            }
        },
        {
            key: "action",
            text: "Action",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ userId, _id, status }) => {
                if (status == 'Empty') return '-'
                return (
                    <button
                        onClick={() => {
                            setIsBankModalOpen(true)
                            setWithdrawId(_id);
                            setWithdrawStatus(status);
                            setUpdateUsrId(userId?._id)
                        }}
                        className="p-2 text-indigo-600 hover:bg-indigo-100 rounded-lg transition-colors"
                    >
                        <Banknote className="w-5 h-5" />
                    </button>
                )
            }
        },
    ];
    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, search: "" });
    const [isBankModalOpen, setIsBankModalOpen] = useState(false);
    const [updateUsrId, setUpdateUsrId] = useState('');
    const [withdrawId, setWithdrawId] = useState('');
    const [withdrawStatus, setWithdrawStatus] = useState('');

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getWithdrawHistory(pagination);
            setLoader(false);
            if (status === true) {
                setData(result.data)
                setCount(result.count)
            }
        } catch (err) {
            setLoader(false);
        }
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [pagination])

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 p-4 md:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full">
                                <Wallet className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Withdraw History</h1>
                                {/* <p className="text-gray-600 text-sm">Manage and view all pin numbers</p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    count={count}
                    loader={loader}
                    setPagination={setPagination}
                />
                <BankAccountView
                    isOpen={isBankModalOpen}
                    onClose={() => setIsBankModalOpen(false)}
                    userId={updateUsrId}
                    withdrawId={withdrawId}
                    withdrawStatus={withdrawStatus}
                    fetchData={fetchData}
                />
            </div>
        </div>
    );
};

export default WithdrawHistory;